import { checkUserHasRole } from "../auth/Utils";

export const helpActions = {
  assignments: {
    label: "Browse assignments",
    path: "/assignments",
    roles: ["teacher", "admin", "director_of_learning"],
  },
  createAssignment: {
    label: "Create an assignment",
    path: "/assignments/create",
    roles: ["teacher", "admin", "director_of_learning"],
  },
  createQuiz: {
    label: "Create a quiz",
    path: "/quizzes/create",
    roles: ["teacher", "director_of_learning"],
  },
  quizzes: {
    label: "Browse quizzes",
    path: "/quizzes",
    roles: ["teacher", "director_of_learning"],
  },
  classes: {
    label: "View classes",
    path: "/school/classes",
    roles: ["teacher", "director_of_learning"],
  },
};

export const guidePath = (guide) =>
  `/help/${guide.kind === "example" ? "examples" : "tutorials"}/${guide.slug}`;
export const isHelpPath = (path) => /^\/help(?:\/|$)/i.test(path);

export function resolveHelpAction(guide, user) {
  const action = helpActions[guide.action];
  if (!Object.hasOwn(helpActions, guide.action)) return null;
  if (!user?.isLoggedIn)
    return {
      label: "Sign in to continue",
      path: `/auth/login?redirect=${encodeURIComponent(guidePath(guide))}`,
      explanation: "You can read this guide without an account.",
    };
  if (!user.info)
    return {
      label: "Return to Fruitify",
      path: "/",
      explanation: "Open your account to check feature access.",
    };
  if (!user.info.subscribed)
    return {
      label: "View account access",
      path: "/account/subscriptions",
      explanation: "Account access is required to use this feature.",
    };
  if (
    !user.info.activeContext?.roleAssignment?.role?.code ||
    !action.roles.some((role) => checkUserHasRole({ user, role }))
  )
    return {
      label: "Return to Fruitify",
      path: "/",
      explanation:
        "This action is not available in your current role. You can still read the guide.",
    };
  if (
    guide.availability === "approved-school" &&
    !user.info.activeContext?.hasApprovedSubscription
  )
    return {
      label: "Return to Fruitify",
      path: "/",
      explanation:
        "This feature requires approved-school access. You can still read the guide.",
    };
  return action;
}
